import React from "react";

const TONE_STYLES = {
  success: "bg-green-100 text-green-700 dark:bg-green-400/10 dark:text-green-400",
  danger: "bg-red-100 text-red-700 dark:bg-red-400/10 dark:text-red-400",
  warning: "bg-amber-100 text-amber-700 dark:bg-amber-400/10 dark:text-amber-400",
  info: "bg-blue-100 text-blue-700 dark:bg-blue-400/10 dark:text-blue-400",
  neutral: "bg-gray-100 text-gray-600 dark:bg-white/5 dark:text-gray-300",
};

const StatusBadge = ({ tone = "neutral", children }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${
      TONE_STYLES[tone] || TONE_STYLES.neutral
    }`}
  >
    <span className="bg-current h-1.5 w-1.5 rounded-full" />
    {children}
  </span>
);

export default StatusBadge;
